import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const HsDesignCertIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "HsDesignCert",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.92 2H3.08C2.49 2 2 2.48 2 3.08v25.85c0 .59.48 1.08 1.08 1.08h25.85c.59 0 1.08-.48 1.08-1.08V3.08c0-.59-.48-1.08-1.08-1.08Zm-1.08 5.38v20.46H4.15V4.15h23.69zM6.57 7.15H25.7v7.29H6.58V7.15Zm0 9.85H25.7v7.29H6.58V17Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.31 12.47c0-1.68-.65-3.25-1.83-4.43-.03-.03-.06-.06-.1-.09l-6.37-6.3c-2.22-2.19-5.82-2.19-8.04 0L5.52 8.03a6.283 6.283 0 0 0 0 8.88l2.47 2.42v11.53c0 .41.22.79.57.99.35.21.79.21 1.15 0L16 28.22l6.29 3.63a1.157 1.157 0 0 0 1.14 0c.35-.2.57-.58.57-.99V19.38l2.47-2.47a6.23 6.23 0 0 0 1.83-4.43ZM16 10.7c1.13 0 2.05.92 2.05 2.04s-.92 2.04-2.05 2.04-2.04-.92-2.04-2.04.92-2.04 2.04-2.04m5.72 18.17-5.14-2.97a1.11 1.11 0 0 0-1.14 0l-5.14 2.97v-7.3l.16.16c1.55 1.52 3.58 2.27 5.6 2.27s4.1-.78 5.66-2.33 0 7.2 0 7.2m3.14-13.59-4.77 4.77c-2.21 2.2-5.81 2.22-8.04.04l-4.91-4.81a3.99 3.99 0 0 1 0-5.63l6.45-6.38c.37-.37.81-.62 1.27-.78v6.08c-1.83.51-3.19 2.17-3.19 4.16 0 2.39 1.94 4.33 4.33 4.33s4.33-1.94 4.33-4.33c0-1.99-1.36-3.66-3.19-4.16V2.5c.46.16.89.41 1.26.78l6.45 6.38s.05.05.08.07a4 4 0 0 1-.07 5.56Z"
      })
    })
  }));
};
HsDesignCertIcon.displayName = 'HsDesignCertIcon';